import { NgModule } from '@angular/core';
import { JbFormWrapperModule } from '@shared/form-wrapper';
import { JbAutocompleteModule } from 'jb-component-library';

import { RegionSelectorDialogModule } from '../region-selector-dialog-v2';
import { CitySelectorComponent } from './city-selector.component';
import { CitySelectorFuzzySearchService } from './fuzzy-search/city-selector-fuzzy-search.service';

const MODULES = [
  JbAutocompleteModule,
  RegionSelectorDialogModule,
  JbFormWrapperModule,
];

const DECLARATIONS = [CitySelectorComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  providers: [CitySelectorFuzzySearchService],
  exports: [...MODULES, ...DECLARATIONS],
})
export class CitySelectorModule {}
